
const linkCleanup = {
    imgs: document.querySelectorAll('.jsDownloadImg')  as NodeListOf<HTMLLinkElement>,   
  

    init() {  
       this.downloadFn();      
    },
    downloadFn() {
      this.imgs.forEach(item=>{        
         const link = item.dataset.link as string
         item.href =  link.replace(/[(',)]/g, "");           
      })
    }

}

export default linkCleanup;
